<div class="place-modal-share-wrap" [class.place-modal-share-wrap-white]="appearance==='white'">
    <div first *ngIf="showTip">Share<span extra> this {{type}}</span></div>
    <div last class="flex">
        <a tabindex="0" [class.detail-share-fb]="appearance==='normal'"
            [class.detail-share-fb-white]="appearance==='white'" [class.share-fb-rounded]="appearance==='rounded'"
            (click)="shareToFacebook()" (keypress)="onKeyPress($event, 'facebook')" matTooltip="Share to facebook"
            role="button" aria-label="share to facebook"></a>
        <a tabindex="0" [class.detail-share-tweet]="appearance==='normal'"
            [class.detail-share-tweet-white]="appearance==='white'" [class.share-tweet-rounded]="appearance==='rounded'"
            (click)="tweetEvent()" (keypress)="onKeyPress($event, 'tweet')" matTooltip="Share to tweet" role="button"
            aria-label="share to tweet"></a>
        <a tabindex="0" [class.detail-share-email]="appearance==='normal'"
            [class.detail-share-email-white]="appearance==='white'" [class.share-email-rounded]="appearance==='rounded'"
            (click)="mailEvent()" (keypress)="onKeyPress($event, 'email')" matTooltip="Share by email" role="button"
            aria-label="share by email"></a>
        <!-- <div class="fb-share-button" data-href="https://www.facebook.com/events/736254421168242/" data-layout="button"
            data-size="large"><a target="_blank"
                href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2Fevents%2F736254421168242%2F&amp;src=sdkpreparse"
                class="fb-xfbml-parse-ignore">Share</a></div> -->
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/social.share/social.share.component.html